<!--财务中心 供应商结算 详情-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top: 20px" size="medium">
          <el-form-item label="送货日期：">
            <el-date-picker v-model="searchForm.SEND_DAY" type="date" placeholder="选择日期" clearable
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="采购类型：">
            <el-select filterable v-model="searchForm.PURCHASE_TYPE" placeholder="请选择" clearable>
              <el-option v-for="item in purchaseTypeList" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select filterable v-model="searchForm.IS_CHECKOUT" placeholder="请选择" :clearable="true">
              <el-option v-for="item in 状态列表" :key="item.ID" :label="item.LABEL" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单备注：">
            <el-input v-model="searchForm.REMARKS" placeholder="请输入备注"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="doQueryTable()" :loading="loading">筛选</el-button>
            <el-button type="primary" plain @click="exportBalance()" :loading="loading">导出</el-button>
            <el-button type="primary" plain @click="exportBalanceDetail()" :loading="loading">导出明细</el-button>
            <el-button type="primary" plain @click="printSelectedBill()" :loading="loading">导出结算单</el-button>
            <el-button type="primary" plain @click="exportData()" :loading="loading">单品汇总对账单导出</el-button>
            <el-button type="primary" plain @click="批量结算()" :loading="loading">批量结算</el-button>
            <el-button type="primary" plain @click="打印结算单()" :loading="loading">打印结算单</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table :data="balanceOrderList" border stripe show-summary style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="50" min-width="30" label="序号"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编码" min-width="200"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商名称" min-width="135"></el-table-column>
          <el-table-column prop="REAL_TOTAL_GYS_FEE" label="实收总金额（元）" min-width="100"></el-table-column>
          <el-table-column prop="PAPER_FEE" label="纸质金额（元）" min-width="100"></el-table-column>
          <el-table-column prop="RETURN_FEE" label="退货总金额（元）" min-width="100"></el-table-column>
          <el-table-column prop="BILL_FEE" label="结算总金额（元）" min-width="100"></el-table-column>
          <el-table-column prop="REMARKS" label="订单备注" min-width="100"></el-table-column>


          <el-table-column prop="STATUS" label="结算状态" min-width="100">
            <template slot-scope="scope">
              <span style="color: rgb(103, 194, 58);" v-if="scope.row.STATUS == 10">已结算</span>
              <span style="color: #E6A23C;" v-else-if="scope.row.STATUS == 8">已对账</span>
              <span style="color: rgb(245, 108, 108);" v-else>未结算</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-check" @click="isSettled(scope.row)"
                v-if="scope.row.STATUS != 10">已结算
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 单品汇总对账单导出 -->
    <el-dialog title="单品汇总对账单导出" center :visible.sync="productSummaryStatementVisible" width="600px"
      :close-on-click-modal="false">
      <el-form ref="productSummaryStatementForm" v-model="productSummaryStatementForm">
        <el-form-item label="日期范围：" label-width="150px">
          <el-date-picker v-model="productSummaryStatementForm.date" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
            style="width: 80%">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="供应商：" label-width="150px">
          <el-select filterable v-model="productSummaryStatementForm.SUPPLIER_NAME" placeholder="请选择供应商" style="width: 80%">
            <el-option v-for="item in supplierList" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button @click="exportSingleProductSummaryStatement()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addOrderDetailFun } from 'api/tcBanlance';
import { print } from 'api/warehouseManager';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      状态列表: [{ ID: '0', LABEL: '未结算' }, { ID: '1', LABEL: '已对账' }, { ID: '2', LABEL: '已结算' }],
      balanceOrderList: [],
      loading: false,
      searchForm: {},
      checkedArray: [],
      勾选的订单列表: [],
      productSummaryStatementVisible: false,
      productSummaryStatementForm: {},
      purchaseTypeList: [
        { ID: 1, NAME: '普通采购' },
        { ID: 2, NAME: '直送门店' },
      ],
    };
  },
  computed: {
    // 上一次的搜索结果和条件
    GYS_ORDER_LIST_CONDITION() {
      return this.$store.state.GYS_ORDER_LIST_CONDITION;
    },
  },
  methods: {
    // -----------------------查看每日订单详情
    detail(row) {
      this.$router.push({ path: '/supplierDayList/detail' });
      sessionStorage.setItem('ORDER_ID', row.ORDER_ID);
    },
    // ------------------------搜索
    doQueryTable() {
      this.currentPage = 1;
      this.queryDataList();
    },
    // ----------------------拉取页面
    queryDataList() {
      const params = {
        MONTH: sessionStorage.getItem('MONTH'),
        SUPPLIER_ID: sessionStorage.getItem('ID'),
      };
      for (const key in this.searchForm) {
        if (this.searchForm[key]) {
          params[key] = this.searchForm[key];
        }
      }
      this.loading = true;
      addOrderDetailFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.balanceOrderList = result;
            this.$store.dispatch('SET_GYS_ORDER_LIST_CONDITION', {
              // CONDITION: this.searchForm,
              CURRENT_PAGE: this.currentPage,
            });
          } else {
            this.balanceOrderList = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 导出
    exportBalance() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 17,
        TC_ID: Number(sessionStorage.getItem('tcID')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: sessionStorage.getItem('ID'),
        MONTH: sessionStorage.getItem('MONTH'),
      };
      for (const key in this.searchForm) {
        if (this.searchForm[key]) {
          params[key] = this.searchForm[key];
        }
      }
      http.post(params).then((res) => {
        if (res[0] && res[0].FILE_PATH) {
          window.location.href = res[0].FILE_PATH;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出明细
    exportBalanceDetail() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 18,
        // TC_ID: Number(sessionStorage.getItem('tcID')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: sessionStorage.getItem('ID'),
        MONTH: sessionStorage.getItem('MONTH'),
      };
      for (const key in this.searchForm) {
        if (this.searchForm[key]) {
          params[key] = this.searchForm[key];
        }
      }
      http.post(params).then((res) => {
        if (res[0] && res[0].FILE_PATH) {
          window.location.href = res[0].FILE_PATH;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange(val) {
      this.checkedArray = val.map((item) => item.ORDER_ID);
      this.勾选的订单列表 = val;
    },
    // 导出结算单
    printSelectedBill() {
      if (this.checkedArray.length == 0) {
        this.$message.show({ text: '请先勾选要导出的结算单', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 19,
        ORDER_ID_LIST: this.checkedArray,
      };
      http.post(params).then((res) => {
        if (res[0] && res[0].FILE_PATH) {
          window.location.href = res[0].FILE_PATH;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 更新订单状态为已结算
    isSettled(row) {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 20,
        ORDER_ID: row.ORDER_ID,
      };
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '结算状态更新成功', type: 'success' });
          this.queryDataList();
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    close() {
      this.productSummaryStatementVisible = false;
      this.$refs.productSummaryStatementForm.resetFields();
      this.productSummaryStatementForm = {};
    },
    exportData() {
      this.productSummaryStatementVisible = true;
    },
    打印结算单() {
      if (this.勾选的订单列表.length == 0) {
        this.$message.show({ text: '请先勾选要打印的结算单', type: 'warning' });
        return false;
      }
      const 本次核销 = this.勾选的订单列表.reduce((total, item) => {
        // 兼容 BILL_FEE 为数字/字符串，无效值按 0 处理
        const fee = typeof item.BILL_FEE === 'number' ? item.BILL_FEE : Number(item.BILL_FEE) || 0;
        return total + fee;
      }, 0).toFixed(2);

      let 单据金额合计 = 0;
      let 未付款金额合计 = 0;
      let 本次核销合计 = 0;
      let html = '<div>';
      html += '<div class="main" >';
      html += '<div class="title">供应商结算付款单</div>';
      html += `<div class="head" style="width: 100%; font-size: 20px; display: flex; justify-content: flex-start; gap: 40px;">
  <div class="code" style="flex: 1; min-width: 300px;">供应商：${this.勾选的订单列表[0].SUPPLIER_NAME}</div>
  <div class="code" style="flex: 1; min-width: 120px;">日期：${this.勾选的订单列表[0].SEND_DAY.slice(0, 7)}</div>
  <div class="code" style="flex: 1; min-width: 150px;">单据编号：</div>
</div>`;
      html += `<div class="head" style="width: 100%; font-size: 20px; display: flex; justify-content: flex-start; gap: 40px; margin-top: 10px;">
  <div class="code" style="flex: 1; min-width: 220px;">单据类型：采购收货</div>
  <div class="code" style="flex: 1; min-width: 150px;">本次核销：${本次核销}</div>
  <div class="code" style="flex: 1; min-width: 150px;">本次付款：0</div>
</div>`;
      html += '<div class="head" style="width: 80%; font-size: 20px;"><div class="code" style="font-size: 20px;">结算方式：</div><div class="code" style="font-size: 20px;">摘要：</div></div>';
      html += '<table border="1" cellspacing="0" style="position:relative; width:98%;"><div class="el-table__body el-table__header">';
      html += `<tr style="text-align: center"><td style="width: 40px">序号</td><td style="display:${this.勾选的订单列表};width: 120px">源单编号</td> <td>单据日期</td> <td>单据金额</td> <td  style="width: 80px">已付款金额</td> <td style="width: 80px">未付款金额</td><td style="width: 70px">本次核销</td><td>备注</td> </tr>`;
      html += '</div><div class="el-table__body">';
      this.勾选的订单列表.forEach((item, index) => {
        const billFee = Number(item.BILL_FEE) || 0;
        单据金额合计 += billFee;
        未付款金额合计 += Number(item.BILL_FEE) || 0;
        本次核销合计 += Number(item.BILL_FEE) || 0;
        html += '<tr style="text-align: center;font-size: 14px">';
        html += `<td> ${index + 1} </td> <td>${item.ORDER_CODE}</td> <td>${item.SEND_DAY}</td> <td>${item.BILL_FEE}</td> <td>0</td><td>${item.BILL_FEE}</td><td>${item.BILL_FEE}</td>
                       <td>${item.REMARKS}</td>`;
        html += '</tr>';
      });
      html += '<tr style="text-align: center;font-size: 14px;font-weight: bold;">';
      html += '<td colspan="3">合计</td>';
      html += `<td>${单据金额合计.toFixed(2)}</td>`;
      html += '<td>0</td>';
      html += `<td>${未付款金额合计.toFixed(2)}</td>`;
      html += `<td>${本次核销合计.toFixed(2)}</td>`;
      html += '<td></td>';
      html += '</tr>';
      html += '</div>';
      html += '</table>';
      html += `<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 16px;"><div style="font-size: 16px;">部门：</div><div  style="margin-left: 120px; font-size: 16px;">业务员：</div><div style="margin-left: 120px; font-size: 16px;">制单人：${sessionStorage.getItem('name')}</div><div style="margin-left: 120px; font-size: 16px;">审核人：</div></div>`;
      html += '</div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
    批量结算() {
      if (this.勾选的订单列表.length == 0) {
        this.$message.show({ text: '请勾选需要结算的订单', type: 'warning' });
        return false;
      }
      if (this.勾选的订单列表.some(({ STATUS }) => STATUS == 10)) {
        this.$message.show({ text: '勾选订单存在已结算订单，请重新勾选', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 20,
        ORDER_ID: this.勾选的订单列表.map(({ ORDER_ID }) => ORDER_ID),
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryDataList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 单品汇总对账单导出
    exportSingleProductSummaryStatement() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 29,
        GYS_ID: sessionStorage.getItem('tcId'),
        SUPPLIER_ID: sessionStorage.getItem('ID'),
        // MONTH: sessionStorage.getItem('MONTH'),
        START_DAY: this.productSummaryStatementForm.date[0],
        END_DAY: this.productSummaryStatementForm.date[1],
      };
      if (this.searchForm.PURCHASE_TYPE) {
        params.PURCHASE_TYPE = this.searchForm.PURCHASE_TYPE;
      }
      http.post(params).then((res) => {
        this.productSummaryStatementVisible = false;
        window.location.href = this.$util.getURLLocalHost(res[0].URL[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  created() {
    if (this.GYS_ORDER_LIST_CONDITION.CONDITION) {
      // this.searchForm = this.GYS_ORDER_LIST_CONDITION.CONDITION;
      this.currentPage = this.GYS_ORDER_LIST_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryDataList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/supplierOrderList.vue